<div class="container-fluid">
    <div class="row caja">
        <div *ngIf="descripcion" class="mb-4">
            <p style="font-size: 18px;"><strong>{{descripcion.descripcion}} </strong>({{descripcion.iso}})</p> 
          </div>
          <br>
          <br>
        <cdk-virtual-scroll-viewport [tvsItemSize]="24" [headerHeight]="34" class="wrapper mat-elevation-z2" #datosHistoricos>

            <table mat-table [dataSource]="datasource2">
    
                <tr mat-header-row *matHeaderRowDef="displayedColumns2; sticky: true"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns2;"></tr>
    
                <ng-container matColumnDef="date">
                    <th mat-header-cell *matHeaderCellDef class="">Date</th>
                    <td mat-cell *matCellDef="let element" class="">{{element.date}}</td>
                </ng-container>
    
                <ng-container matColumnDef="open">
                    <th mat-header-cell *matHeaderCellDef>Open</th>
                    <td mat-cell *matCellDef="let element">{{element.open}}</td>
                </ng-container>

                <ng-container matColumnDef="high">
                    <th mat-header-cell *matHeaderCellDef>High</th>
                    <td mat-cell *matCellDef="let element">{{element.high}}</td>
                </ng-container>

                <ng-container matColumnDef="low">
                    <th mat-header-cell *matHeaderCellDef>low</th>
                    <td mat-cell *matCellDef="let element">{{element.low}}</td>
                </ng-container>

                <ng-container matColumnDef="close">
                    <th mat-header-cell *matHeaderCellDef>Close</th>
                    <td mat-cell *matCellDef="let element">{{element.close}}</td>
                </ng-container>

                <ng-container matColumnDef="volume">
                    <th mat-header-cell *matHeaderCellDef>Volume</th>
                    <td mat-cell *matCellDef="let element">{{element.volume}}</td>
                </ng-container>
    
            </table>
    
        </cdk-virtual-scroll-viewport>
    </div>

</div>